import maiaCanvasBrush from '@longfor/canvasbrush' //es6
// const maiaCanvasBrush = require('@longfor/canvasbrush') //commonjs

const watermark = maiaCanvasBrush({
  wrapper:'app',
  text: [],
  // color: ['rgba(137,130,129, 0.6)'],
  color: ['rgba(204, 204, 204, 0.2)'],
  angle: -30,
  fontsize: 14,
  x_space: 150,
  y_space: 120,
  // x_space_ratio: 2,
  y_space_ratio: 1,
  // resize: false,
  // show_threshold: 1.5, // 超出部分如何显示
  //compact: true, // 紧凑型 适用于文本长度很长且旋转角度偏大的场景
  password: '1234'
})

export default watermark

// 更新水印组件
// watermark.update({
//     // 需要传递password
//     password: '1234',
//     text: [
//         'john 2019-08-20',
//         '内部资料禁止外传',
//     ],
// })
// // 删除水印组件
// watermark.remove('1234')
